// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1fFAB","label":"CategoryService_label__15jb_","location":"CategoryService_location__2awyj"};